export default __webpack_public_path__ + "17d42eab2c301309bc65aaa60d80996e.png";